module.exports = __webpack_public_path__ + "img/unpin.8342b674.svg";